import { BrowserRouter as Router, Link, Route, Routes } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import axios from "axios";
import './App.css';
import logo from './logo.png'; // Importing the image
import { Helmet } from 'react-helmet';
import twitter from './twitterr.png'; // Importing the image
import { Disclosure, RadioGroup, Tab } from '@headlessui/react'
import { StarIcon } from '@heroicons/react/solid'
import { HeartIcon, MinusSmIcon, PlusSmIcon } from '@heroicons/react/outline'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: '#E5E5E5',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
};
const product = {
  name: 'Zip Tote Basket',
  price: '$140',
  rating: 4,
  images: [
    {
      id: 1,
      name: 'Angled view',
      src: 'https://tailwindui.com/img/ecommerce-images/product-page-03-product-01.jpg',
      alt: 'Angled front view with bag zipped and handles upright.',
    },
    // More images...
  ],
  colors: [
    { name: 'Washed Black', bgColor: 'bg-gray-700', selectedColor: 'ring-gray-700' },
    { name: 'White', bgColor: 'bg-white', selectedColor: 'ring-gray-400' },
    { name: 'Washed Gray', bgColor: 'bg-gray-500', selectedColor: 'ring-gray-500' },
  ],
  description: `
    <p>The Zip Tote Basket is the perfect midpoint between shopping tote and comfy backpack. With convertible straps, you can hand carry, should sling, or backpack this convenient and spacious bag. The zip top and durable canvas construction keeps your goods protected for all-day use.</p>
  `,
  details: [
    {
      name: 'Features',
      items: [
        'Multiple strap configurations',
        'Spacious interior with top zip',
        'Leather handle and tabs',
        'Interior dividers',
        'Stainless strap loops',
        'Double stitched construction',
        'Water-resistant',
      ],
    },
    // More sections...
  ],
}

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

// Import all images from the 'images' directory

// Play component (this is a placeholder, you can replace it with your actual play component)
const PlayPage = () => {
  const [randomImage, setRandomImage] = useState(null);
  const [RealHead, setRealHead] = useState('');
  const [RealBody, setRealBody] = useState('');
  const [RealType1, setRealType1] = useState('');
  const [RealType2, setRealType2] = useState('');

  const [selectedHead, setSelectedHead] = useState('Head');
  const [selectedBody, setSelectedBody] = useState('Body');
  const [selectedType1, setSelectedType1] = useState('');
  const [selectedType2, setSelectedType2] = useState('');
  const [Headurl, setHeadUrl] = useState("");
  const [Bodyurl, setBodyUrl] = useState("");
  const [imageFilename, setImageFilename] = useState('');
  const [imageFilenameCredit, setImageFilenameCredit] = useState('');

  const [pokemonList, setPokemonList] = useState('');
  const [filter, setFilter] = useState('');
  const [filter2, setFilter2] = useState('');
  const [ArtBy, setArtBy] = useState('');
  const [clickReload, setClickReload] = useState(false);

  const [isBodyCorrect, setIsBodyCorrect] = useState(false);
  const [isHeadCorrect, setIsHeadCorrect] = useState(false);
  const [isType1Correct, setIsType1Correct] = useState(false);
  const [isType2Correct, setIsType2Correct] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [selectedColor, setSelectedColor] = useState(product.colors[0])

  const pokemonOptions = [
   "Bulbasaur","Ivysaur","Venusaur","Charmander","Charmeleon","Charizard","Squirtle","Wartortle","Blastoise","Caterpie","Metapod","Butterfree","Weedle","Kakuna","Beedrill","Pidgey","Pidgeotto","Pidgeot","Rattata","Raticate","Spearow","Fearow","Ekans","Arbok","Pikachu","Raichu","Sandshrew","Sandslash","Nidoran F","Nidorina","Nidoqueen","Nidoran M","Nidorino","Nidoking","Clefairy","Clefable","Vulpix","Ninetales","Jigglypuff","Wigglytuff","Zubat","Golbat","Oddish","Gloom","Vileplume","Paras","Parasect","Venonat","Venomoth","Diglett","Dugtrio","Meowth","Persian","Psyduck","Golduck","Mankey","Primeape","Growlithe","Arcanine","Poliwag","Poliwhirl","Poliwrath","Abra","Kadabra","Alakazam","Machop","Machoke","Machamp","Bellsprout","Weepinbell","Victreebel","Tentacool","Tentacruel","Geodude","Graveler","Golem","Ponyta","Rapidash","Slowpoke","Slowbro","Magnemite","Magneton","Farfetch'd","Doduo","Dodrio","Seel","Dewgong","Grimer","Muk","Shellder","Cloyster","Gastly","Haunter","Gengar","Onix","Drowzee","Hypno","Krabby","Kingler","Voltorb","Electrode","Exeggcute","Exeggutor","Cubone","Marowak","Hitmonlee","Hitmonchan","Lickitung","Koffing","Weezing","Rhyhorn","Rhydon","Chansey","Tangela","Kangaskhan","Horsea","Seadra","Goldeen","Seaking","Staryu","Starmie","Mr. Mime","Scyther","Jynx","Electabuzz","Magmar","Pinsir","Tauros","Magikarp","Gyarados","Lapras","Ditto","Eevee","Vaporeon","Jolteon","Flareon","Porygon","Omanyte","Omastar","Kabuto","Kabutops","Aerodactyl","Snorlax","Articuno","Zapdos","Moltres","Dratini","Dragonair","Dragonite","Mewtwo","Mew","Chikorita","Bayleef","Meganium","Cyndaquil","Quilava","Typhlosion","Totodile","Croconaw","Feraligatr","Sentret","Furret","Hoothoot","Noctowl","Ledyba","Ledian","Spinarak","Ariados","Crobat","Chinchou","Lanturn","Pichu","Cleffa","Igglybuff","Togepi","Togetic","Natu","Xatu","Mareep","Flaaffy","Ampharos","Bellossom","Marill","Azumarill","Sudowoodo","Politoed","Hoppip","Skiploom","Jumpluff","Aipom","Sunkern","Sunflora","Yanma","Wooper","Quagsire","Espeon","Umbreon","Murkrow","Slowking","Misdreavus","Unown","Wobbuffet","Girafarig","Pineco","Forretress","Dunsparce","Gligar","Steelix","Snubbull","Granbull","Qwilfish","Scizor","Shuckle","Heracross","Sneasel","Teddiursa","Ursaring","Slugma","Magcargo","Swinub","Piloswine","Corsola","Remoraid","Octillery","Delibird","Mantine","Skarmory","Houndour","Houndoom","Kingdra","Phanpy","Donphan","Porygon2","Stantler","Smeargle","Tyrogue","Hitmontop","Smoochum","Elekid","Magby","Miltank","Blissey","Raikou","Entei","Suicune","Larvitar","Pupitar","Tyranitar","Lugia","Ho-Oh","Celebi","Azurill","Wynaut","Ambipom","Mismagius","Honchkrow","Bonsly","Mime Jr.","Happiny","Munchlax","Mantyke","Weavile","Magnezone","Lickilicky","Rhyperior","Tangrowth","Electivire","Magmortar","Togekiss","Yanmega","Leafeon","Glaceon","Gliscor","Mamoswine","Porygon-Z","Treecko","Grovyle","Sceptile","Torchic","Combusken","Blaziken","Mudkip","Marshtomp","Swampert","Ralts","Kirlia","Gardevoir","Gallade","Shedinja","Kecleon","Beldum","Metang","Metagross","Bidoof","Spiritomb","Lucario","Gible","Gabite","Garchomp","Mawile","Lileep","Cradily","Anorith","Armaldo","Cranidos","Rampardos","Shieldon","Bastiodon","Slaking","Absol","Duskull","Dusclops","Dusknoir","Wailord","Arceus","Turtwig","Grotle","Torterra","Chimchar","Monferno","Infernape","Piplup","Prinplup","Empoleon","Nosepass","Probopass","Honedge","Doublade","Aegislash","Pawniard","Bisharp","Luxray","Aggron","Flygon","Milotic","Salamence","Klinklang","Zoroark","Sylveon","Kyogre","Groudon","Rayquaza","Dialga","Palkia","Giratina","Regigigas","Darkrai","Genesect","Reshiram","Zekrom","Kyurem","Roserade","Drifblim","Lopunny","Breloom","Ninjask","Banette","Rotom","Reuniclus","Whimsicott","Krookodile","Cofagrigus","Galvantula","Ferrothorn","Litwick","Lampent","Chandelure","Haxorus","Golurk","Pyukumuku","Klefki","Talonflame","Mimikyu","Volcarona","Deino","Zweilous","Hydreigon","Latias","Latios","Deoxys","Jirachi","Nincada","Bibarel","Riolu","Slakoth","Vigoroth","Wailmer","Shinx","Luxio","Aron","Lairon","Trapinch","Vibrava","Feebas","Bagon","Shelgon","Klink","Klang","Zorua","Budew","Roselia","Drifloon","Buneary","Shroomish","Shuppet","Solosis","Duosion","Cottonee","Sandile","Krokorok","Yamask","Joltik","Ferroseed","Axew","Fraxure","Golett","Fletchling","Fletchinder","Larvesta","Stunfisk","Sableye","Venipede","Whirlipede","Scolipede","Tyrunt","Tyrantrum","Snorunt","Glalie","Froslass","Oricorio Baile Style","Oricorio Pom-Pom Style","Oricorio Pa'u Style","Oricorio Sensu Style","Trubbish","Garbodor","Carvanha","Sharpedo","Phantump","Trevenant","Noibat","Noivern","Swablu","Altaria","Goomy","Sliggoo","Goodra","Regirock","Regice","Registeel","Necrozma","Ultra Necrozma","Stufful","Bewear","Dhelmise","Mareanie","Toxapex","Hawlucha","Cacnea","Cacturne","Sandygast","Palossand","Amaura","Aurorus","Rockruff","Lycanroc Midday","Lycanroc Midnight"
      ];
      const [filteredOptions, setFilteredOptions] = useState(pokemonOptions);
      const [filtered2Options, setFiltered2Options] = useState(pokemonOptions);

  const handleFilterChange = (e) => {
    const input = e.target.value;
    setFilter(input);
    const newFilteredOptions = pokemonOptions.filter(pokemon => 
      pokemon.toLowerCase().includes(input.toLowerCase())
    );
    setFilteredOptions(newFilteredOptions);
  };
  const handleFilter2Change = (e) => {
    const input = e.target.value;
    setFilter2(input);
    const newFilteredOptions = pokemonOptions.filter(pokemon => 
      pokemon.toLowerCase().includes(input.toLowerCase())
    );
    setFiltered2Options(newFilteredOptions);
  };
  const pokemonTypes = [
    'Normal', 'Fire', 'Water', 'Grass', 'Electric', 'Ice', 'Fighting', 'Poison',
    'Ground', 'Flying', 'Psychic', 'Bug', 'Rock', 'Ghost', 'Dark', 'Steel', 'Fairy','Dragon'
    // Add more types as needed
  ];
  useEffect(() => {
  
    const fetchPokemon = async () => {

        const res = await axios.get(`https://pokeapi.co/api/v2/pokemon?limit=100000&offset=0.`);
        const names = res.data.results.map(pokemon => pokemon.name);

        setPokemonList(names);

    };
    fetchPokemon()
  }, []);

  useEffect(() => {
    axios.get(`https://fusionbackend.onrender.com/pokemon-by-number/${imageFilename.split('.')[0]}`)
        .then(response => {
            setRealHead(response.data.pokemonName.toLowerCase());
        })
        .catch(error => console.error('Error fetching pokemon:', error));
        axios.get(`https://fusionbackend.onrender.com/pokemon-by-number/${imageFilename.split('.')[1]}`)
        .then(response => {
            setRealBody(response.data.pokemonName.toLowerCase());
        })
        .catch(error => console.error('Error fetching pokemon:', error));
}, [imageFilename]);




  useEffect(() => {
    console.log("getting image");
    setRandomImage();
    axios.get('https://fusionbackend.onrender.com/random-image')
        .then(response => {
            setRandomImage(response.data.imageUrl);

            const cleanedFileName = response.data.imageName.replace(/([a-zA-Z]+)(?=\.\w+$)/, '');
            setImageFilename(cleanedFileName);
            setImageFilenameCredit(response.data.imageName)
        })
        .catch(error => console.error('Error fetching random image:', error));


}, [clickReload]);
  
useEffect(() => {
  axios.get(`https://fusionbackend.onrender.com/name-by-number/${imageFilenameCredit.replace('.png', '')}`)
      .then(response => {
          setArtBy(response.data.name);
          //setName(response.data.name);
      })
      .catch(error => console.error('Error fetching name:', error));
}, [imageFilenameCredit]);





  const pokeFuncHead = async (Name) => {
    try {
      const res = await axios.get(`https://pokeapi.co/api/v2/pokemon/${Name}/`);
      setRealType1(res.data.types[0].type.name)

    } catch (error) {
      console.error('Error fetching data from PokeAPI:', error);
    }
  };
  const pokeFuncBody = async (Name) => {
    try {
      const res = await axios.get(`https://pokeapi.co/api/v2/pokemon/${Name}/`);
      if(res.data.types.length > 1)
      {
        setRealType2(res.data.types[1].type.name)
      }
      else{
        setRealType2(res.data.types[0].type.name)
      }

    } catch (error) {
      console.error('Error fetching data from PokeAPI:', error);
    }
  };
  useEffect(() => {
    // Function to import all images from the 'images' directory

    pokeFuncHead(RealHead);
    pokeFuncBody(RealBody);

  }, [RealHead,RealBody]);

  useEffect(() => {
    if(selectedHead.toLowerCase() === RealHead.toLowerCase() && selectedBody.toLowerCase() === RealBody.toLowerCase() ){
      setIsCompleted(true);
    }
  }, [selectedHead,selectedBody]);


  const handleHeadChange = (e) => {
    setSelectedHead(e.target.value);
  };

  const handleBodyChange = (e) => {
    setSelectedBody(e.target.value);
  };

  const handleType1Change = (e) => {
    setSelectedType1(e.target.value);
  };

  const handleType2Change = (e) => {
    setSelectedType2(e.target.value);
  };

  const handleButtonClick = () => {
    setSelectedBody('');
    setSelectedHead('');
    setIsCompleted(false);
  //window.location.reload();
  if(clickReload == false){
    setClickReload(true);
  }
  else{
    setClickReload(false);
  }
  setIsBodyCorrect(false);
  setIsHeadCorrect(false);


  };
  return (
    <div className="bg-inherit">
      <div className="max-w-2xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="lg:grid lg:grid-cols-2  lg:items-start">
          {/* Image gallery */}
          <img
                    src={randomImage}
                    alt="Sprite"
                    className="w-full h-full py-1 object-center object-cover sm:rounded-lg"
                  />

          {/* Product info */}
          <div className="mt-10 px-4 lg:py-14 sm:px-0 sm:mt-16 lg:mt-0">
            <h1 className="text-xl font-extrabold tracking-tight text-gray-900">Art by:   {ArtBy.trim() === '' ? 
    'Coming soon' : 
    <a className="text-black" href={`https://if.daena.me/artists/${ArtBy.trim()}`} target="_blank" rel="noopener noreferrer">{ArtBy}</a>
  }</h1>
 




            <div className="mt-6 ">
              {/* Colors */}


              <div className="mt-10 flex sm:flex-col1">
              <div className="autocomplete-container">          
      <input
      className="border-double border-4 border-gray-500  max-w-xs flex-1 bg-indigo-600 border border-transparent rounded-md py-3 px-8 flex items-center justify-center text-base font-medium text-black hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-indigo-500 sm:w-full"
        
        type="text"
        value={filter}
        onChange={handleFilterChange}
        placeholder={selectedHead}
        style={{ backgroundColor: isHeadCorrect ? '#16A34A' : 'white' }}
        disabled={isHeadCorrect}
      />
      {filter && (
        <div className="autocomplete-options">
          {filteredOptions.map((pokemon, index) => (
            <div
              key={index}
              className="autocomplete-option"
              onClick={() => {
                setSelectedHead(pokemon);
                setFilter('');
                if(pokemon.toLowerCase() == RealHead){
                  setIsHeadCorrect(true);
                }
                else{
                  setIsHeadCorrect(false);
                }
              }}
            >
              {pokemon}
            </div>
          ))}
        </div>
      )}
</div>
</div>
<div className="mt-10 flex sm:flex-col2">
<div className="autocomplete-container">
    <input
        
        type="text"
        className="border-double border-4 border-gray-500 max-w-xs flex-1 bg-indigo-600 border border-transparent rounded-md py-3 px-8 flex items-center justify-center text-base font-medium text-black hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-indigo-500 sm:w-full"
        value={filter2}
        onChange={handleFilter2Change}
        placeholder={selectedBody}
        style={{ backgroundColor: isBodyCorrect ? '#16A34A' : 'white' }}
        disabled={isBodyCorrect}
      />
      {filter2 && (
        <div className="autocomplete-options">
          {filtered2Options.map((pokemon, index) => (
            <div
              key={index}
              className="autocomplete-option"
              onClick={() => {
                setSelectedBody(pokemon);
                setFilter2('');
                if(pokemon.toLowerCase() == RealBody){
                  setIsBodyCorrect(true);
                }
                else{
                  setIsBodyCorrect(false);
                }
              }}
            >
              {pokemon}
            </div>
          ))}
        </div>
      )}
</div>

              </div>


              <div className="mt-10 flex sm:flex-col1">
              {isCompleted &&<button
              onClick={handleButtonClick}
                  
                  className="max-w-xs flex-1 bg-green-600 border border-transparent rounded-md py-3 px-8 flex items-center justify-center text-base font-medium text-white hover:bg-green-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-indigo-500 sm:w-full"
                >
                  Play Again
                </button>}


              </div>

            </div>


          </div>
        </div>
      </div>
    </div>
  )
};

// Home component
const HomePage = ({ handlePlayClick, handleOptionsClick }) => {
  const [open1, setOpen1] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);

  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);

  return (
    <div style={{ display: 'flex', flexDirection: 'column',  alignItems: 'center', justifyContent: 'center', height: '100vh', paddingTop: '20px' }}>
      {/* Play button with Link to the "/play" route */}
      <button
        onClick={handleOptionsClick}
        class="bg-white text-black font-bold py-2 px-4 rounded opacity-50 cursor-not-allowed "
      >
        Daily (coming soon)
      </button>
      <Link to="/play" >
        <button
          onClick={handlePlayClick}
          class="bg-white hover:bg-gray-700 text-black font-bold py-2 px-4 rounded-full mt-6 "
        >
          Free Play
        </button>
      </Link>

      {/* Options button */}
      <button
        onClick={handleOpen1}
        class="bg-white hover:bg-gray-700 text-black font-bold py-2 px-4 rounded-full mt-6 mb-6"
      >
        How to play
      </button>
      <button
        onClick={handleOpen2}
        class="bg-white hover:bg-gray-700 text-black font-bold py-2 px-4 rounded-full "
      >
        About
      </button>
      <Modal
    open={open1}
    onClose={handleClose1}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
  >
  <Box sx={style}>
    <Typography id="modal-modal-title" variant="h6" component="h2">
      How To Play :
      <img src={logo} alt="Logo" className="logo" />
    </Typography>
    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
    <p>Welcome to my personal project FusioGuess! In this game, your task is to unravel the mystery behind unique Pokémon fusions. You'll be presented with an image featuring a fusion of two Pokémon – one for the head and another for the body, complete with a distinctive color palette. Your challenge is to use your Pokémon knowledge to identify both the head and the body that come together to form this extraordinary fusion.
    </p>
    <p>Study the details carefully, as the color palette and characteristics of each Pokémon play a crucial role in solving the puzzle. Once you feel confident in your guess, submit your answer and see if you can correctly identify the two Pokémon that make up the fusion. With a mix of creativity, Pokémon expertise, and a keen eye for details, you'll soon find yourself immersed in the delightful world of FusioGuess. Get ready to embark on a journey of discovery and showcase your Pokémon mastery!
    </p></Typography>
  </Box>
</Modal>
<Modal
    open={open2}
    onClose={handleClose2}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
  >
  <Box sx={style}>
    <Typography id="modal-modal-title" variant="h6" component="h2">
      About
      <img src={logo} alt="Logo" className="logo" />

    </Typography>
    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
      <p>Made by Draginhell.</p>
      <p>This project is a distinct and independent game, not affiliated with the Infinite Fusion project, and does not own or claim any rights to the game</p>
      <p>FusioQuiz gets its sprites and credits from the Sprite Packs released once a month.</p>
      <p>If you like this project, be sure to check out  <a style={{color : "red"}} target="_blank" href="https://discord.com/invite/infinitefusion">Pokemon Infinite Fusion</a></p>
      <p>Neither FusioQuiz nor Pokémon: Infinite Fusion are affiliated with The Pokémon Company, Nintendo, Game Freak Inc., or Creatures Inc.</p>

    
    </Typography>
  </Box>
</Modal>
    </div>
  );
};

// Define the App component
function App() {
  // State to track the high score
  const [highScore, setHighScore] = useState(0);
  const [showPopup, setShowPopup] = useState(false);

  const handleInfoClick = () => {
      setShowPopup(true);
  };

  const closePopup = () => {
      setShowPopup(false);
  };
  // Event handler for the play button
  const handlePlayClick = () => {
    // Add your play logic or navigate to the play page here
    // For now, let's navigate to the "/play" route
   
  };

  // Event handler for the options button
  const handleOptionsClick = () => {
    // Add your options logic here

  };

  return (
    <Router>
            <Helmet>
        <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5153126455381819" crossorigin="anonymous"></script>
      </Helmet>
      <div style={{ fontFamily: 'Arial, sans-serif', position: 'relative' }}>
      <nav class="navbar">
    <div class="navbar-brand">
    <Link to="/">
  <img src={logo} alt="Logo" className="navbar-logo" />
</Link>    </div>
    <div class="navbar-icons">
        <a href="https://twitter.com/fusionquizgame" target="_blank" >
            <img style={{ paddingRight : '10px'}} src={twitter} alt="Twitter" class="icon"/>
            
        </a>
        </div>


</nav>



        {/*  
        <div style={{ position: 'absolute', top: 10, left: 10, fontSize: '18px' }}>
          High Score: {highScore}
        </div>*/
}
        {/* Define routes */}
        <Routes>
          
          <Route
            path="/play"
            element={<PlayPage />}
          />
          <Route
            path="/"
            element={<HomePage handlePlayClick={handlePlayClick} handleOptionsClick={handleOptionsClick} />}
          />
        </Routes>
        <div class="divfooter"><div class="css-e1a8s4"><p class="chakra-text footerparagraph">FusioQuiz is not affiliated with Nintendo and does not own or claim any rights to any Nintendo trademark or the Pokémon trademark, and all references to such are used for commentary and informational purposes only.</p></div></div>
      </div>
    </Router>
  );
}

export default App;
